import { getExpiryDetails } from "./trungThuExpiry";

const compareStockRowLabels = (firstRow, secondRow) => {
  const firstLabel = `${firstRow.Ten_SP || ""} ${firstRow.MaSP || ""}`;
  const secondLabel = `${secondRow.Ten_SP || ""} ${secondRow.MaSP || ""}`;
  const productComparison = firstLabel.localeCompare(secondLabel, "vi", {
    numeric: true,
    sensitivity: "base",
  });

  if (productComparison !== 0) return productComparison;

  return String(firstRow.LoSX || "").localeCompare(
    String(secondRow.LoSX || ""),
    "vi",
    { numeric: true, sensitivity: "base" }
  );
};

const getStockRowSortDetails = (row, referenceDate) => {
  const stockQuantity = Number(row.TonConLai) || 0;
  const daysRemaining = getExpiryDetails(
    row.NgaySD,
    referenceDate
  ).daysRemaining;
  const shouldMoveToBottom =
    stockQuantity <= 0 || (daysRemaining !== null && daysRemaining < 0);

  return {
    stockQuantity,
    daysRemaining,
    shouldMoveToBottom,
  };
};

export const filterTrungThuStockRows = (
  stockRows,
  { hideEmptyStock = false, searchValue = "" } = {}
) => {
  const normalizedSearchValue = searchValue.trim().toLocaleLowerCase("vi");

  return stockRows.filter((row) => {
    if (hideEmptyStock && (Number(row.TonConLai) || 0) <= 0) {
      return false;
    }

    if (!normalizedSearchValue) return true;

    return [row.Ten_SP, row.MaSP, row.LoSX].some((value) =>
      String(value ?? "")
        .toLocaleLowerCase("vi")
        .includes(normalizedSearchValue)
    );
  });
};

export const sortTrungThuStockRows = (
  stockRows,
  { sortByExpiry = false, referenceDate = new Date() } = {}
) =>
  [...stockRows].sort((firstRow, secondRow) => {
    const firstDetails = getStockRowSortDetails(firstRow, referenceDate);
    const secondDetails = getStockRowSortDetails(secondRow, referenceDate);

    if (
      !sortByExpiry &&
      firstDetails.shouldMoveToBottom !== secondDetails.shouldMoveToBottom
    ) {
      return firstDetails.shouldMoveToBottom ? 1 : -1;
    }

    if (sortByExpiry) {
      const firstDaysRemaining =
        firstDetails.daysRemaining ?? Number.POSITIVE_INFINITY;
      const secondDaysRemaining =
        secondDetails.daysRemaining ?? Number.POSITIVE_INFINITY;

      if (firstDaysRemaining !== secondDaysRemaining) {
        return firstDaysRemaining - secondDaysRemaining;
      }
    }

    if (firstDetails.stockQuantity !== secondDetails.stockQuantity) {
      return secondDetails.stockQuantity - firstDetails.stockQuantity;
    }

    if (!sortByExpiry) {
      const firstDaysRemaining =
        firstDetails.daysRemaining ?? Number.NEGATIVE_INFINITY;
      const secondDaysRemaining =
        secondDetails.daysRemaining ?? Number.NEGATIVE_INFINITY;

      if (firstDaysRemaining !== secondDaysRemaining) {
        return secondDaysRemaining - firstDaysRemaining;
      }
    }

    return compareStockRowLabels(firstRow, secondRow);
  });
